// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"121":"vendor","524":"app"}[chunkId] + "." + {"121":"4fc3b081ca21e86cd6f0","524":"801549e7530e12263aa6"}[chunkId] + ".css";
};